import styled from "styled-components";

export const PanicButtonPopupTimeBox = styled.span`
      color: ${({theme}) => theme.colors.brandSecondary}; 
      padding-left: 0.5rem;
      padding-right: 0.5rem;
`;